/**
 * RefundStatusChip (Plan 44).
 *
 * Compact badge for the parent-visible refund state on the family-
 * balance transactions list. Renders one of 5 statuses keyed off the
 * latest `RefundProposal` for an OrderItem:
 *
 *   - "Refund processing" — auto-approved within the cancellation
 *     window; the wallet credit is in-flight (the next ledger fetch
 *     flips this to "Refunded").
 *   - "Awaiting Ordo review" — proposal queued for ORDO_ADMIN review.
 *   - "Refunded" — proposal approved + AR ledger written.
 *   - "Refund rejected" — proposal reviewed + rejected; no money
 *     moved.
 *   - "Refund cancelled" — proposer withdrew before review.
 *
 * The status comes from the `/api/refunds/status/:orderItemId`
 * endpoint; this component is the pure rendering surface.
 */

import { Badge } from '@ordo/ui/badge'

import { type ParentRefundStatus, parentRefundStatusLabel, parentRefundStatusTone } from './refund-cause-picker-helpers'

export interface RefundStatusChipProps {
  status: ParentRefundStatus
  /** Optional title text — surfaces the rejection reason or the cause. */
  title?: string | null
}

export function RefundStatusChip({ status, title }: RefundStatusChipProps) {
  return (
    <Badge variant={parentRefundStatusTone(status)} title={title ?? undefined}>
      {parentRefundStatusLabel(status)}
    </Badge>
  )
}
